<template>
    <div class="activity-modal requisition input-full-width">
        <div class="modal-header">
            <h2 class="text-center">{{data.activity.activityType}}</h2>
        </div>

        <div class="form hide-for-small-only">
            <div class="grid-x align-items">
                <div class="medium-1 small-2 cell flexbox-center">
                    <icon class="info small-svg" name="info" />
                </div>
                <div class="medium-3 small-5 cell flexbox-align-items">
                    <label for="">Bemærkning</label>
                </div>
                <div class="auto cell" style="max-height: 150px; overflow-y: auto;">
                    <p style="max-width: 600px; white-space: pre; max-height: 250px; text-wrap: wrap;" id="remark" v-html="data.activity.description"></p>
                </div>
            </div>
        </div>
        <div class="grid-x" v-if="data.activity.hyperlink">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form hide-for-small-only" v-if="data.activity.hyperlink">
            <div class="grid-x align-items">
                <div class="medium-1 small-2 cell flexbox-center">
                    <icon class="link small-svg" name="link" />
                </div>
                <div class="medium-3 small-5 cell flexbox-align-items">
                    <label for="">Link</label>
                </div>
                <div class="large-1 cell">
                    <a :href="data.activity.hyperlink" target="_blank">
                        <p style="max-width: 600px; white-space: pre; max-height: 250px;" id="hyperlink" v-if="data.activity.hyperlink.length < 50">{{ data.activity.hyperlink }}</p>
                        <p style="max-width: 600px; white-space: pre; max-height: 250px;" id="hyperlink" v-else>{{ data.activity.hyperlink.substring(0, 50).concat('...') }}</p>
                    </a>
                </div>
            </div>
        </div>
        <div class="grid-x" v-if="data.objectId">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form hide-for-small-only" v-if="data.objectId">
            <div class="grid-x align-items">
                <div class="medium-1 small-2 cell flexbox-center">
                    <icon class="bubble small-svg" name="bubble" />
                </div>
                <div class="medium-3 small-5 cell">
                    <label for="reportNote">Note</label>
                </div>
                <div class="auto cell">
                    <textarea id="reportNote" type="text" rows="4" cols="30" v-model="note"></textarea>
                </div>
            </div>
        </div>
        <div class="grid-x" v-if="data.activity.reference">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="form hide-for-small-only" v-if="data.activity.reference">
            <div class="grid-x align-items">
                <div class="medium-1 small-1 cell flexbox-center">
                    <icon class="dollar small-svg" name="dollar" />
                </div>
                <div class="medium-3 small-3 cell">
                    <label for="reference">Reference</label>
                </div>
                <div class="auto cell">
                    <p id="remark2">{{data.activity.reference}}</p>
                </div>
            </div>
        </div>
        <div class="grid-x">
            <div class="small-1 cell flexbox-center"></div>
            <div class="auto cell">
                <hr />
            </div>
        </div>
        <div class="modal-body show-for-small-only">
            <div class="form">
                <div class="grid-x header">
                    <div class="cell small-1 flexbox-centertext">
                        <icon class="info small-svg" name="info" />
                    </div>
                    <div class="cell small-11">
                        <label for="">Bemærkning</label>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell small-12" style="max-height: 150px; overflow-y: auto;">
                        <p id="remark" style="white-space: pre;" v-html="data.activity.description"></p>
                    </div>
                </div>
            </div>
            <div class="form" v-if="data.activity.hyperlink">
                <div class="grid-x header">
                    <div class="cell small-1 flexbox-centertext">
                        <icon class="link small-svg" name="link" />
                    </div>
                    <div class="cell small-11">
                        <label for="hyperlink">Link</label>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell small-12">
                        <a :href="data.activity.hyperlink" target="_blank">
                            <p id="hyperlink" v-if="data.activity.hyperlink.length < 20">{{ data.activity.hyperlink }}</p>
                            <p id="hyperlink" v-else>{{ data.activity.hyperlink.substring(0, 20).concat('...') }}</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="form">
                <div class="grid-x header">
                    <div class="cell small-1 flexbox-centertext">
                        <icon class="bubble small-svg" name="bubble" />
                    </div>
                    <div class="cell small-11">
                        <label for="reportNote">Note</label>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell small-12">
                        <textarea id="reportNote" class="text-area-form" type="text" rows="3" cols="20" v-model="note"></textarea>
                    </div>
                </div>
            </div>
            <div class="form" v-if="data.activity.reference">
                <div class="grid-x header">
                    <div class="cell small-1 flexbox-centertext">
                        <icon class="dollar small-svg" name="dollar" />
                    </div>
                    <div class="cell small-11">
                        <label for="reference">Reference</label>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell small-12">
                        <p id="remark2">{{data.activity.reference}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="text-center modal-buttons" v-if="data.objectId">
                <button type="button" class="button-green" @click="saveActivityNote(data.activity)">Gem</button>
                <button type="button" class="button-naked" @click="closeModal()">Fortryd</button>
            </div>
            <div v-else class="text-center modal-buttons">
                <button type="button" class="button-naked" @click="closeModal()">Luk vindue</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'requisition-modal-activity',
    data () {
        return {
            note: ''
        }
    },
    props: {
        data: Object
    },
    computed: {
        ...mapGetters({
            objectActivityVersionStamp: 'getObjectActivityVersionStamp'
        })
    },
    methods: {
        ...mapActions({
            reportObjectNote: 'setReportObjectNote',
            setObjectActivityVersionStamp: 'setObjectActivityVersionStamp'
        }),
        closeModal () {
            this.$emit('close')
        },
        saveActivityNote (activity) {
            let data = {
                requisitionId: this.data.requisitionId,
                activityId: activity.activityId,
                objectId: this.data.objectId,
                reportNote: this.note,
                objectActivityVersionStamp: activity.objectActivityVersionStamp
            }
            new Promise((resolve, reject) => {
                resolve(this.reportObjectNote(data))
            }).then(() => {
                activity.objectActivityVersionStamp = this.objectActivityVersionStamp
                this.closeModal()
            })
        }
    },
    created () {
        this.setObjectActivityVersionStamp(this.data.activity.activityVersionStamp)
        if (this.data.activity.reportNote) {
            this.note = JSON.parse(JSON.stringify(this.data.activity.reportNote))
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/requisition/requisition-modal-activity.vue